<template>
  <div>
    <v-alert
      dense
      text
      type="info"
    >
      Rechnung und Buchungsbeleg werden direkt mit der richtigen Dokumentart gespeichert.
      Es kann auch nur eine der beiden Dateien hochgeladen werden.
    </v-alert>

    <div class="mb-5">
      <label
        class="font-weight-bold d-block mb-1"
        :for="rechnungInputId"
      >
        Rechnung (PDF)
      </label>
      <input
        :id="rechnungInputId"
        ref="rechnungInput"
        data-testid="kosten-rechnung-datei"
        type="file"
        accept="application/pdf,.pdf"
        class="kosten-beleg-datei"
        @change="selectFile('rechnung', $event)"
      >
    </div>

    <div class="mb-5">
      <label
        class="font-weight-bold d-block mb-1"
        :for="buchungsbelegInputId"
      >
        Buchungsbeleg (PDF)
      </label>
      <input
        :id="buchungsbelegInputId"
        ref="buchungsbelegInput"
        data-testid="kosten-buchungsbeleg-datei"
        type="file"
        accept="application/pdf,.pdf"
        class="kosten-beleg-datei"
        @change="selectFile('buchungsbeleg', $event)"
      >
    </div>

    <v-alert
      v-if="message"
      dense
      text
      :type="messageType"
    >
      {{ message }}
    </v-alert>

    <div class="d-flex justify-end">
      <v-btn
        color="success"
        :disabled="!rechnung && !buchungsbeleg"
        :loading="uploading"
        @click="upload"
      >
        <v-icon left>
          mdi-cloud-upload
        </v-icon>
        Belege hochladen
      </v-btn>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  props: {
    apipath: {
      type: String,
      required: true,
    },
    datum: {
      type: String,
      default: '',
    },
  },
  data() {
    const inputIdPrefix = `kosten-beleg-${Math.random().toString(36).slice(2)}`;
    return {
      rechnungInputId: `${inputIdPrefix}-rechnung`,
      buchungsbelegInputId: `${inputIdPrefix}-buchungsbeleg`,
      rechnung: null,
      buchungsbeleg: null,
      uploading: false,
      message: '',
      messageType: 'info',
    };
  },
  methods: {
    selectFile(type, event) {
      const [file] = event.target.files;
      this[type] = file || null;
      this.message = '';
    },
    resetFiles() {
      this.rechnung = null;
      this.buchungsbeleg = null;
      this.$refs.rechnungInput.value = '';
      this.$refs.buchungsbelegInput.value = '';
    },
    upload() {
      if (!this.rechnung && !this.buchungsbeleg) {
        this.messageType = 'warning';
        this.message = 'Bitte mindestens eine Datei auswählen.';
        return;
      }

      const formData = new FormData();
      if (this.rechnung) {
        formData.append('rechnung', this.rechnung);
      }
      if (this.buchungsbeleg) {
        formData.append('buchungsbeleg', this.buchungsbeleg);
      }
      formData.append('datum', this.datum || '');

      this.uploading = true;
      this.message = '';
      $.ajax({
        url: `${process.env.VUE_APP_API_HOST}/${this.apipath}`,
        type: 'POST',
        data: formData,
        dataType: 'json',
        processData: false,
        contentType: false,
        success: (response) => {
          if (response.status === 'accessError') {
            this.$store.commit('login/backendErrorSession');
            return;
          }
          if (response.status === 'error') {
            this.messageType = 'error';
            this.message = response.message || 'Die Belege konnten nicht hochgeladen werden.';
            return;
          }

          const dokumente = response.neuDokument || [];
          if (dokumente.length > 0) {
            this.$emit('neuDokumente', dokumente);
            this.messageType = 'success';
            this.message = `${dokumente.length} Beleg${dokumente.length === 1 ? '' : 'e'} erfolgreich hochgeladen.`;
            this.resetFiles();
          }
        },
        error: () => {
          this.messageType = 'error';
          this.message = 'Die Belege konnten nicht hochgeladen werden. Bitte die Netzwerkverbindung prüfen.';
        },
        complete: () => {
          this.uploading = false;
        },
      });
    },
  },
};
</script>

<style scoped>
.kosten-beleg-datei {
  display: block;
  width: 100%;
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.02);
}
</style>
